$(document).ready(function(){
  //Toggle stands
  $('#no_stands').change(function() {
    if( $(this).prop("checked") ){
      updateTag('add');
    }
    else{
      updateTag('remove');
    }
  });
});
function updateTag(command){
  $.ajax({
    url : __api_config.host+"/api/customer/"+command+"_tag?id="+__api_config.customer_id+"&dt="+__api_config.dt+"&signed="+__api_config.signed+"&tag="+__api_config.tag,
    type: "GET",
    success: function(data, textStatus, jqXHR){
      if( data["status"]!="success" ) return;
      let text = "";
      if( command=="remove" ) text = "No prob! We’ll include them.";
      else text = "Sounds good! We’ll leave them out.";
      Swal.fire({
        html: text,
        showDenyButton: false,
        showCancelButton: false,
        showConfirmButton: true,
        allowEscapeKey: true,
        allowOutsideClick: true,
      }).then((result) => {});
    },
    error: function (jqXHR, textStatus, errorThrown){
    }
  });
}